const headerTemplate = document.querySelector(".header-template");
headerTemplate.innerHTML += "<script src='./lumis-theme/br/com/safra/financeira/theme/safra-financeira/scripts/components/template.js'></script>"

document.addEventListener('DOMContentLoaded', function () {

  localStorage.setItem('pagina', 'template');

  // Tagueamento de visualização da página
  preencherLibSat('page_view', {
    event: 'pageview:landing-page-template:home:visualizou:tela',
    contentGroupping: 'fin:landing-page-template',
    page: 'fin:landing-page-template:home',
  });
  
});
